import type { SqlLanguage } from "sql-formatter";

import { getFormatSql } from "src/utils/lazy-sql-formatter";

const formatterLanguageBySourceType: Record<string, SqlLanguage> = {
  athena: "hive",
  bigquery: "bigquery",
  mssql: "tsql",
  mysql: "mysql",
  postgres: "postgresql",
  redshift: "redshift",
  snowflake: "postgresql",
  trino: "postgresql",
  clickhouse: "postgresql",
  databricks: "postgresql",
  looker: "postgresql",
  metabase: "postgresql",
};

export function formatSourceSql(
  source: {
    id: string;
    type: string;
    name: string;
    definition: { name: string; icon: string; isSampleDataSource: boolean };
  },
  sql: string,
): string {
  const formatFn = getFormatSql();
  if (!formatFn) {
    // sql-formatter hasn't loaded yet; return unformatted SQL.
    // This should be rare since the import starts eagerly at module load.
    return sql;
  }
  const formatterLanguage = formatterLanguageBySourceType[source.type];
  return formatFn(sql, {
    keywordCase: "upper",
    language: formatterLanguage ?? undefined,
  });
}

export { formatterLanguageBySourceType };
